module.exports = __webpack_public_path__ + "img/delete.4eed37af.svg";